<template>
  <!-- 首页轮播图 -->
  <div class="home-banner">
    <el-carousel height="628px" class="relative">
      <el-carousel-item v-for="item in bannerList" :key="item.id">
        <img :src="item.logo" alt="" />
        <div class="absolute">
          <div
            class="title"
            :style="item.id == 2 || item.id == 3 ? 'color: #fff' : ''"
          >
            {{ item.title }}
          </div>
          <div
            class="text"
            :style="item.id == 2 || item.id == 3 ? 'color: #fff' : ''"
          >
            {{ item.text }}
          </div>
          <div
            class="experience"
            :style="
              item.id == 2 || item.id == 3
                ? 'color: #fff; border: 1px solid #fff'
                : ''
            "
            @click="experienceClick"
          >
            立即体验
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
  <Experience
    v-if="experienceShow"
    :experienceShow="experienceShow"
    @experienceClick="experienceClick"
  ></Experience>
</template>

<script>
import { reactive } from "vue";

import Experience from "../../../components/pc/components/Experience.vue";

import banner1 from "../../../assets/home/banner1.png";
import banner2 from "../../../assets/home/banner2.png";
import banner3 from "../../../assets/home/banner3.png";

export default {
  setup() {
    return reactive({
      bannerList: [
        {
          id: 1,
          logo: banner1,
          title: "畅月数字家园管理系统",
          text: "畅月数字家园管理系统是使物业、居委、业主、商家通过软硬一体化设备让智慧社区更具备运营能力 、盈利能力；使社区生活更加方便、快捷。",
        },
        {
          id: 2,
          logo: banner2,
          title: "移动办公",
          text: "APP+小程序全面实现移动办公，物业工作随时处理，效率更高更便捷",
        },
        {
          id: 3,
          logo: banner3,
          title: "智慧物业一体化优质服务商",
          text: "赋能物业、居委，助力物业智能化、数字化升级，打造智慧化社区新生态",
        },
      ],
      experienceShow: false,
    });
  },
  components: {
    Experience,
  },
  methods: {
    experienceClick() {
      this.experienceShow = !this.experienceShow;
    },
  },
};
</script>

<style scoped>
.home-banner img {
  width: 100%;
  height: 628px;
}
@media screen and (max-width: 1180px) {
  .home-banner {
    min-width: 1180px;
  }
}
:deep(.el-carousel__indicators--horizontal) {
  bottom: 20%;
  left: 23%;
}
.relative {
  position: relative;
}
.absolute {
  position: absolute;
  z-index: 999;
  top: 20%;
  left: 20%;
}
.absolute .title {
  font-size: 30px;
  color: #248efb;
}
.absolute .text {
  width: 490px;
  font-size: 14px;
  margin-top: 30px;
  color: #248efb;
}
.absolute .experience {
  margin-top: 60px;
  font-size: 16px;
  color: #248efb;
  width: 108px;
  height: 36px;
  line-height: 36px;
  border: 1px solid #248efb;
  border-radius: 6px 6px 6px 6px;
  text-align: center;
  cursor: pointer;
}
</style>
